import { atom } from "recoil";

export const IsSignedIn = atom<boolean | undefined>({
  key: "userSignIn",
  default: undefined,
});
